import { render, staticRenderFns } from "./QuestionCard.vue?vue&type=template&id=2502feed&scoped=true"
import script from "./QuestionCard.vue?vue&type=script&lang=js"
export * from "./QuestionCard.vue?vue&type=script&lang=js"
import style0 from "./QuestionCard.vue?vue&type=style&index=0&id=2502feed&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2502feed",
  null
  
)

export default component.exports